/**
 * The quick status filter belonging to one tab.
 *
 * Every kept-alive tab's table is mounted at once, so handing them all the module's
 * single "current" filter means each tab switch changes the filter under every one
 * of them: they refetch with a filter belonging to some other tab, overwrite that
 * tab's shipment count with the result, and reset its page, because a changed
 * filter sends a table back to page 1. Each table reads its own tab's filter here
 * instead, and a tab switch leaves the others alone.
 *
 * `null` is a real value — All Statuses — so only a tab that has never had a filter
 * set falls back to the module default.
 */
export const resolveTabFilter = (listViewState = {}, stateKey, fallback = null) => {
  const tabState = listViewState[stateKey];
  return tabState && "filter" in tabState ? tabState.filter : fallback;
};

export default resolveTabFilter;
